module.exports = __webpack_public_path__ + "img/folder-fill.e55ce1e7.svg";